'use client';

import { useQuery } from '@tanstack/react-query';
import type { ProductInventoryResponse } from '../queries/get-product-inventory';

async function getProductInventory(
  id: string | null
): Promise<ProductInventoryResponse> {
  if (!id) return null;

  const response = await fetch(`/api/cart/get-product-inventory?id=${id}`);

  if (!response.ok) {
    return null;
  }

  const json = await response.json();

  if (json.data) {
    return json.data;
  }

  return null;
}

export function useProductInventory(productId: string | null) {
  const isClient = typeof window !== 'undefined';

  const query = useQuery({
    queryKey: ['productInventory', productId],
    queryFn: async () => {
      const response = await getProductInventory(productId);
      return response;
    },
    enabled: !!productId && isClient,
    staleTime: 5 * 60 * 1000, // 5 minutes - don't refetch for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });

  // Consistent isOutOfStock calculation that handles all edge cases
  const isOutOfStock =
    !query.isLoading &&
    query.data !== undefined &&
    query.data !== null &&
    query.data.availableForSale === false;

  return {
    ...query,
    isOutOfStock,
  };
}
